var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar',{attrs:{"toggleable":"lg"}},[_c('router-link',{staticClass:"bt-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.$root.config.common.Header.logo}})]),(!_vm.$root.isMobile && _vm.current_step < 8)?_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',{staticClass:"ml-auto mr-auto"},[_c('b-nav-item',{staticClass:"px-4",class:{
          active: _vm.current_step < 5,
          complete: _vm.current_step >= 5
        }},[_vm._v("Creá tu cuenta")]),_c('b-nav-item',{staticClass:"px-4",class:{
          active: _vm.current_step == 5,
          complete: _vm.current_step > 5
        }},[_vm._v("¿Quién sos?")]),_c('b-nav-item',{staticClass:"px-4",class:{
          active: _vm.current_step == 6,
          complete: _vm.current_step > 6
        }},[_vm._v("¿Qué hacés?")]),_c('b-nav-item',{staticClass:"px-4",class:{
          active: _vm.current_step == 7,
          complete: _vm.current_step > 7
        }},[_vm._v("¿Qué buscas?")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }